module.exports = __webpack_public_path__ + "static/media/stat1.3631d455.svg";